// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.application-view {
  padding: 24px;
  background: #f8fafc;
  height: 800px;
  overflow-y: auto;
  width: 700px;

  /* Hide scrollbar */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE & Edge */
}

.application-view::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari */
}

.candidate-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  padding: 24px;
  border-radius: 16px;
  margin-bottom: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
}

.candidate-avatar {

  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: #2563eb;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}

.candidate-info {
  flex: 1 1;
  margin-left: 20px;
}

.candidate-info h2 {
  margin: 0;
  font-size: 24px;
  color: #172033;
  font-weight: 800;
}

.candidate-info p {
  color: #64748b;
  margin-top: 4px;
}

.status-badge {
  background: #dcfce7;
  color: #16a34a;
  padding: 8px 18px;
  border-radius: 30px;
  font-weight: 600;
}

.view-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.view-card h3 {
  margin-bottom: 20px;
  color: #1e293b;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.info-item {
  display: flex;
  gap: 15px;
  align-items: flex-start;
}

.info-item svg {
  color: #2563eb;
  font-size: 18px;
}

.info-item label {
  display: block;
  font-size: 12px;
  color: #94a3b8;
}

.info-item span {
  font-weight: 600;
  color: #334155;
}

.remarks-box {
  background: #f8fafc;
  padding: 16px;
  border-radius: 12px;
  line-height: 1.6;
}

.document-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 15px;
}

.document-card {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #334155;
  transition: 0.3s;
  cursor: pointer;
}

.document-card:hover {
  border-color: #2563eb;
  transform: translateY(-3px);
}

.document-card svg {
  font-size: 30px;
  color: #2563eb;
  margin-bottom: 10px;
}


.candidate-status {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}

.status-badge {
  padding: 10px 18px;
  border-radius: 30px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: .4px;
}

.process-1 {
  background: #2563eb;
}

.process-2 {
  background: #f59e0b;
}

.process-3 {
  background: #10b981;
}

.process-btn {
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 10px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  transition: .25s;
  box-shadow: 0 8px 18px rgba(0, 0, 0, .15);
}

.process-btn:hover {
  transform: translateY(-2px);
}

.process-btn.completed {
  background: #10b981;
  cursor: default;
}


.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn .25s ease;
}

.confirm-modal {
  width: 420px;
  background: white;
  border-radius: 18px;
  padding: 30px;
  text-align: center;
  animation: popup .25s ease;
  box-shadow: 0 25px 60px rgba(0, 0, 0, .2);
}

.confirm-icon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: #fff4e5;
  color: #ff9800;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  font-size: 32px;
}

.confirm-modal h2 {
  margin: 20px 0 10px;
  color: #222;
}

.confirm-modal p {
  color: #666;
  line-height: 24px;
  margin-bottom: 25px;
}

.confirm-buttons {
  display: flex;
  gap: 15px;
}

.cancel-btn {
  flex: 1 1;
  padding: 12px;
  border: none;
  border-radius: 10px;
  background: #ececec;
  cursor: pointer;
  font-weight: 600;
}

.cancel-btn:hover {
  background: #ddd;
}

.confirm-btn {
  flex: 1 1;
  padding: 12px;
  border: none;
  border-radius: 10px;
  color: white;
  background: #2563eb;
  cursor: pointer;
  font-weight: 600;
  transition: .3s;
}

.confirm-btn:hover {
  background: #1d4ed8;
}

@keyframes popup {
  from {
    transform: scale(.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.application-view.application-view-standalone {
  width: 100%;
  max-width: 1220px;
  height: auto;
  min-height: calc(100vh - 120px);
  margin: 0 auto;
  padding: 4px 0 32px;
  overflow: visible;
  background: transparent;
  animation: applicationPageIn .28s ease both;
}

.application-view-standalone .candidate-header,
.application-view-standalone .view-card {
  border: 1px solid #e8edf4;
  border-radius: 20px;
}

.application-view-standalone .candidate-header {
  background: linear-gradient(135deg, #fff 30%, #eff6ff);
  box-shadow: 0 12px 36px rgba(15, 23, 42, .08);
}

.application-page-back {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 18px;
  padding: 10px 14px;
  border: 1px solid #dbe3ef;
  border-radius: 11px;
  background: #fff;
  color: #475569;
  font-weight: 700;
  cursor: pointer;
}

.application-page-back:hover { border-color: #2563eb; color: #2563eb; }
.application-page-type { display: block; margin-bottom: 4px; color: #2563eb; font-weight: 800; letter-spacing: .05em; text-transform: uppercase; }
.document-card small { margin-top: 5px; color: #94a3b8; font-size: 11px; }
.document-card-missing { opacity: .52; cursor: default; }
.document-card-missing:hover { border-color: #e2e8f0; transform: none; }

.application-page-state {
  display: grid;
  min-height: 55vh;
  place-content: center;
  justify-items: center;
  padding: 30px;
  text-align: center;
  color: #64748b;
}
.application-page-state h2 { margin: 14px 0 5px; color: #1e293b; }
.application-page-state p { margin: 0 0 18px; }
.application-page-state > span { display: flex; gap: 9px; }
.application-page-state button { display: inline-flex; align-items: center; gap: 7px; padding: 10px 14px; border: 1px solid #dbe3ef; border-radius: 10px; background: #fff; color: #2563eb; font-weight: 700; cursor: pointer; }
.application-page-error > div { display: grid; width: 62px; height: 62px; place-items: center; border-radius: 50%; background: #fef2f2; color: #dc2626; font-size: 26px; font-weight: 900; }
.application-page-spinner { width: 42px; height: 42px; border: 4px solid #dbeafe; border-top-color: #2563eb; border-radius: 50%; animation: applicationPageSpin .8s linear infinite; }

@keyframes applicationPageIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
@keyframes applicationPageSpin { to { transform: rotate(360deg); } }

@media (max-width: 700px) {
  .application-view.application-view-standalone { padding-bottom: 20px; }
  .application-view-standalone .candidate-header { align-items: flex-start; flex-wrap: wrap; padding: 18px; }
  .application-view-standalone .candidate-status { width: 100%; align-items: stretch; }
  .application-view-standalone .process-btn { width: 100%; }
}

.application-process-actions { display: flex; flex-wrap: wrap; justify-content: flex-end; gap: 9px; }
.application-process-actions .process-btn { display: inline-flex; align-items: center; justify-content: center; gap: 7px; white-space: nowrap; }
.application-process-actions .interview-action { background: linear-gradient(135deg, #2563eb, #1d4ed8); }
.application-process-actions .placement-action { background: linear-gradient(135deg, #059669, #047857); }
.application-process-card { overflow: hidden; }
.application-process-heading { display: flex; align-items: flex-start; justify-content: space-between; gap: 18px; margin-bottom: 26px; }
.application-process-heading small { display: block; margin-bottom: 5px; color: #2563eb; font-size: 11px; font-weight: 800; letter-spacing: .12em; }
.application-process-heading h3 { margin: 0 0 5px; }
.application-process-heading p { margin: 0; color: #64748b; font-size: 13px; }
.application-process-heading > span { padding: 7px 11px; border: 1px solid #bfdbfe; border-radius: 999px; background: #eff6ff; color: #1d4ed8; font-size: 12px; font-weight: 800; white-space: nowrap; }
.application-process-timeline { position: relative; display: grid; gap: 18px; padding-left: 6px; }
.application-process-timeline::before { position: absolute; top: 20px; bottom: 20px; left: 22px; width: 2px; background: #dbeafe; content: ""; }
.application-timeline-event { position: relative; display: grid; grid-template-columns: 34px minmax(0, 1fr); gap: 16px; }
.application-timeline-marker { z-index: 1; display: grid; width: 34px; height: 34px; place-items: center; border: 4px solid #fff; border-radius: 50%; background: #2563eb; box-shadow: 0 0 0 1px #bfdbfe; color: #fff; font-size: 13px; }
.application-timeline-event.submitted .application-timeline-marker { background: #64748b; }
.application-timeline-event.placed .application-timeline-marker { background: #059669; box-shadow: 0 0 0 1px #a7f3d0; }
.application-timeline-content { min-width: 0; padding: 14px 16px; border: 1px solid #e2e8f0; border-radius: 14px; background: #fff; box-shadow: 0 4px 16px rgba(15,23,42,.04); }
.application-timeline-title { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; }
.application-timeline-title h4 { margin: 0; color: #0f172a; font-size: 15px; }
.application-timeline-title time { display: inline-flex; align-items: center; gap: 5px; color: #64748b; font-size: 11px; white-space: nowrap; }
.application-timeline-slot { display: inline-flex; align-items: center; gap: 7px; margin-top: 10px; padding: 7px 10px; border-radius: 8px; background: #eff6ff; color: #1d4ed8; font-size: 12px; font-weight: 700; }
.application-timeline-feedback { display: flex; gap: 10px; margin-top: 12px; padding: 11px 12px; border-left: 3px solid #93c5fd; border-radius: 8px; background: #f8fafc; color: #475569; }
.application-timeline-feedback > svg { flex: 0 0 auto; margin-top: 2px; color: #2563eb; }
.application-timeline-feedback small { color: #64748b; font-size: 10px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; }
.application-timeline-feedback p { margin: 3px 0 0; color: #334155; line-height: 1.55; white-space: pre-wrap; overflow-wrap: anywhere; }
.application-timeline-author { margin-top: 9px; color: #94a3b8; font-size: 11px; text-align: right; }
.placement-feedback-form { margin-top: 16px; }
@media (max-width: 700px) {
  .application-process-actions { width: 100%; justify-content: stretch; }
  .application-process-actions .process-btn { flex: 1 1 100%; }
  .application-process-heading, .application-timeline-title { align-items: flex-start; flex-direction: column; }
  .application-process-heading { gap: 10px; }
  .application-timeline-title { gap: 6px; }
  .application-timeline-title time { white-space: normal; }
}`, "",{"version":3,"sources":["webpack://./src/forms/ApplicationView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,YAAY;;EAEZ,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qDAAqD;EACrD,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;IACpB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sDAAsD;EACtD,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,+BAA+B,qBAAqB,EAAE,cAAc,EAAE;AACtE,yBAAyB,cAAc,EAAE,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AACjJ,uBAAuB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACzE,yBAAyB,YAAY,EAAE,eAAe,EAAE;AACxD,+BAA+B,qBAAqB,EAAE,eAAe,EAAE;;AAEvE;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;AACA,6BAA6B,kBAAkB,EAAE,cAAc,EAAE;AACjE,4BAA4B,gBAAgB,EAAE;AAC9C,iCAAiC,aAAa,EAAE,QAAQ,EAAE;AAC1D,iCAAiC,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC/N,gCAAgC,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC3L,4BAA4B,WAAW,EAAE,YAAY,EAAE,yBAAyB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,kDAAkD,EAAE;;AAErL,+BAA+B,OAAO,UAAU,EAAE,0BAA0B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AAC7H,iCAAiC,KAAK,yBAAyB,EAAE,EAAE;;AAEnE;EACE,gDAAgD,oBAAoB,EAAE;EACtE,iDAAiD,uBAAuB,EAAE,eAAe,EAAE,aAAa,EAAE;EAC1G,iDAAiD,WAAW,EAAE,oBAAoB,EAAE;EACpF,4CAA4C,WAAW,EAAE;AAC3D;;AAEA,+BAA+B,aAAa,EAAE,eAAe,EAAE,yBAAyB,EAAE,QAAQ,EAAE;AACpG,4CAA4C,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC/I,iDAAiD,qDAAqD,EAAE;AACxG,iDAAiD,qDAAqD,EAAE;AACxG,4BAA4B,gBAAgB,EAAE;AAC9C,+BAA+B,aAAa,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACvI,qCAAqC,cAAc,EAAE,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACnJ,kCAAkC,eAAe,EAAE;AACnD,iCAAiC,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AAC7E,sCAAsC,iBAAiB,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACvM,gCAAgC,kBAAkB,EAAE,aAAa,EAAE,SAAS,EAAE,iBAAiB,EAAE;AACjG,wCAAwC,kBAAkB,EAAE,SAAS,EAAE,YAAY,EAAE,UAAU,EAAE,UAAU,EAAE,mBAAmB,EAAE,WAAW,EAAE;AAC/I,8BAA8B,kBAAkB,EAAE,aAAa,EAAE,0CAA0C,EAAE,SAAS,EAAE;AACxH,+BAA+B,UAAU,EAAE,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,6BAA6B,EAAE,WAAW,EAAE,eAAe,EAAE;AACxO,qEAAqE,mBAAmB,EAAE;AAC1F,kEAAkE,mBAAmB,EAAE,6BAA6B,EAAE;AACtH,gCAAgC,YAAY,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,yCAAyC,EAAE;AAC/K,8BAA8B,aAAa,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,SAAS,EAAE;AACjH,iCAAiC,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AAC7E,mCAAmC,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAC9I,6BAA6B,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACnN,iCAAiC,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC1L,uCAAuC,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE;AACxF,uCAAuC,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AAC5I,mCAAmC,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE,qBAAqB,EAAE,uBAAuB,EAAE;AACvI,+BAA+B,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE;AACpG,2BAA2B,gBAAgB,EAAE;AAC7C;EACE,+BAA+B,WAAW,EAAE,wBAAwB,EAAE;EACtE,4CAA4C,cAAc,EAAE;EAC5D,4DAA4D,uBAAuB,EAAE,sBAAsB,EAAE;EAC7G,+BAA+B,SAAS,EAAE;EAC1C,8BAA8B,QAAQ,EAAE;EACxC,mCAAmC,mBAAmB,EAAE;AAC1D","sourcesContent":[".application-view {\n  padding: 24px;\r\n  background: #f8fafc;\r\n  height: 800px;\r\n  overflow-y: auto;\r\n  width: 700px;\r\n\r\n  /* Hide scrollbar */\r\n  scrollbar-width: none;\r\n  /* Firefox */\r\n  -ms-overflow-style: none;\r\n  /* IE & Edge */\r\n}\r\n\r\n.application-view::-webkit-scrollbar {\r\n  display: none;\r\n  /* Chrome, Safari */\r\n}\r\n\r\n.candidate-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background: white;\r\n  padding: 24px;\r\n  border-radius: 16px;\r\n  margin-bottom: 20px;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.candidate-avatar {\r\n\r\n  width: 70px;\r\n  height: 70px;\r\n  border-radius: 50%;\r\n  background: #2563eb;\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 28px;\r\n}\r\n\r\n.candidate-info {\r\n  flex: 1;\r\n  margin-left: 20px;\r\n}\r\n\r\n.candidate-info h2 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  color: #172033;\r\n  font-weight: 800;\r\n}\r\n\r\n.candidate-info p {\r\n  color: #64748b;\r\n  margin-top: 4px;\r\n}\r\n\r\n.status-badge {\r\n  background: #dcfce7;\r\n  color: #16a34a;\r\n  padding: 8px 18px;\r\n  border-radius: 30px;\r\n  font-weight: 600;\r\n}\r\n\r\n.view-card {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  margin-bottom: 20px;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.view-card h3 {\r\n  margin-bottom: 20px;\r\n  color: #1e293b;\r\n}\r\n\r\n.info-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n.info-item {\r\n  display: flex;\r\n  gap: 15px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.info-item svg {\r\n  color: #2563eb;\r\n  font-size: 18px;\r\n}\r\n\r\n.info-item label {\r\n  display: block;\r\n  font-size: 12px;\r\n  color: #94a3b8;\r\n}\r\n\r\n.info-item span {\r\n  font-weight: 600;\r\n  color: #334155;\r\n}\r\n\r\n.remarks-box {\r\n  background: #f8fafc;\r\n  padding: 16px;\r\n  border-radius: 12px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.document-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\r\n  gap: 15px;\r\n}\r\n\r\n.document-card {\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 14px;\r\n  padding: 20px;\r\n  text-align: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-decoration: none;\r\n  color: #334155;\r\n  transition: 0.3s;\r\n  cursor: pointer;\r\n}\r\n\r\n.document-card:hover {\r\n  border-color: #2563eb;\r\n  transform: translateY(-3px);\r\n}\r\n\r\n.document-card svg {\r\n  font-size: 30px;\r\n  color: #2563eb;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n\r\n.candidate-status {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  gap: 12px;\r\n}\r\n\r\n.status-badge {\r\n  padding: 10px 18px;\r\n  border-radius: 30px;\r\n  color: #fff;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  letter-spacing: .4px;\r\n}\r\n\r\n.process-1 {\r\n  background: #2563eb;\r\n}\r\n\r\n.process-2 {\r\n  background: #f59e0b;\r\n}\r\n\r\n.process-3 {\r\n  background: #10b981;\r\n}\r\n\r\n.process-btn {\r\n  border: none;\r\n  outline: none;\r\n  cursor: pointer;\r\n  border-radius: 10px;\r\n  padding: 10px 18px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: white;\r\n  background: linear-gradient(135deg, #2563eb, #4f46e5);\r\n  transition: .25s;\r\n  box-shadow: 0 8px 18px rgba(0, 0, 0, .15);\r\n}\r\n\r\n.process-btn:hover {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.process-btn.completed {\r\n  background: #10b981;\r\n  cursor: default;\r\n}\r\n\r\n\r\n.confirm-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, .45);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 9999;\r\n  animation: fadeIn .25s ease;\r\n}\r\n\r\n.confirm-modal {\r\n  width: 420px;\r\n  background: white;\r\n  border-radius: 18px;\r\n  padding: 30px;\r\n  text-align: center;\r\n  animation: popup .25s ease;\r\n  box-shadow: 0 25px 60px rgba(0, 0, 0, .2);\r\n}\r\n\r\n.confirm-icon {\r\n  width: 70px;\r\n  height: 70px;\r\n  border-radius: 50%;\r\n  background: #fff4e5;\r\n  color: #ff9800;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: auto;\r\n  font-size: 32px;\r\n}\r\n\r\n.confirm-modal h2 {\r\n  margin: 20px 0 10px;\r\n  color: #222;\r\n}\r\n\r\n.confirm-modal p {\r\n  color: #666;\r\n  line-height: 24px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.confirm-buttons {\r\n  display: flex;\r\n  gap: 15px;\r\n}\r\n\r\n.cancel-btn {\r\n  flex: 1;\r\n  padding: 12px;\r\n  border: none;\r\n  border-radius: 10px;\r\n  background: #ececec;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n}\r\n\r\n.cancel-btn:hover {\r\n  background: #ddd;\r\n}\r\n\r\n.confirm-btn {\r\n  flex: 1;\r\n  padding: 12px;\r\n  border: none;\r\n  border-radius: 10px;\r\n  color: white;\r\n  background: #2563eb;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  transition: .3s;\r\n}\r\n\r\n.confirm-btn:hover {\r\n  background: #1d4ed8;\r\n}\r\n\r\n@keyframes popup {\r\n  from {\r\n    transform: scale(.8);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\n\n.application-view.application-view-standalone {\n  width: 100%;\n  max-width: 1220px;\n  height: auto;\n  min-height: calc(100vh - 120px);\n  margin: 0 auto;\n  padding: 4px 0 32px;\n  overflow: visible;\n  background: transparent;\n  animation: applicationPageIn .28s ease both;\n}\n\n.application-view-standalone .candidate-header,\n.application-view-standalone .view-card {\n  border: 1px solid #e8edf4;\n  border-radius: 20px;\n}\n\n.application-view-standalone .candidate-header {\n  background: linear-gradient(135deg, #fff 30%, #eff6ff);\n  box-shadow: 0 12px 36px rgba(15, 23, 42, .08);\n}\n\n.application-page-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  margin-bottom: 18px;\n  padding: 10px 14px;\n  border: 1px solid #dbe3ef;\n  border-radius: 11px;\n  background: #fff;\n  color: #475569;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.application-page-back:hover { border-color: #2563eb; color: #2563eb; }\n.application-page-type { display: block; margin-bottom: 4px; color: #2563eb; font-weight: 800; letter-spacing: .05em; text-transform: uppercase; }\n.document-card small { margin-top: 5px; color: #94a3b8; font-size: 11px; }\n.document-card-missing { opacity: .52; cursor: default; }\n.document-card-missing:hover { border-color: #e2e8f0; transform: none; }\n\n.application-page-state {\n  display: grid;\n  min-height: 55vh;\n  place-content: center;\n  justify-items: center;\n  padding: 30px;\n  text-align: center;\n  color: #64748b;\n}\n.application-page-state h2 { margin: 14px 0 5px; color: #1e293b; }\n.application-page-state p { margin: 0 0 18px; }\n.application-page-state > span { display: flex; gap: 9px; }\n.application-page-state button { display: inline-flex; align-items: center; gap: 7px; padding: 10px 14px; border: 1px solid #dbe3ef; border-radius: 10px; background: #fff; color: #2563eb; font-weight: 700; cursor: pointer; }\n.application-page-error > div { display: grid; width: 62px; height: 62px; place-items: center; border-radius: 50%; background: #fef2f2; color: #dc2626; font-size: 26px; font-weight: 900; }\n.application-page-spinner { width: 42px; height: 42px; border: 4px solid #dbeafe; border-top-color: #2563eb; border-radius: 50%; animation: applicationPageSpin .8s linear infinite; }\n\n@keyframes applicationPageIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }\n@keyframes applicationPageSpin { to { transform: rotate(360deg); } }\n\n@media (max-width: 700px) {\n  .application-view.application-view-standalone { padding-bottom: 20px; }\n  .application-view-standalone .candidate-header { align-items: flex-start; flex-wrap: wrap; padding: 18px; }\n  .application-view-standalone .candidate-status { width: 100%; align-items: stretch; }\n  .application-view-standalone .process-btn { width: 100%; }\n}\n\n.application-process-actions { display: flex; flex-wrap: wrap; justify-content: flex-end; gap: 9px; }\n.application-process-actions .process-btn { display: inline-flex; align-items: center; justify-content: center; gap: 7px; white-space: nowrap; }\n.application-process-actions .interview-action { background: linear-gradient(135deg, #2563eb, #1d4ed8); }\n.application-process-actions .placement-action { background: linear-gradient(135deg, #059669, #047857); }\n.application-process-card { overflow: hidden; }\n.application-process-heading { display: flex; align-items: flex-start; justify-content: space-between; gap: 18px; margin-bottom: 26px; }\n.application-process-heading small { display: block; margin-bottom: 5px; color: #2563eb; font-size: 11px; font-weight: 800; letter-spacing: .12em; }\n.application-process-heading h3 { margin: 0 0 5px; }\n.application-process-heading p { margin: 0; color: #64748b; font-size: 13px; }\n.application-process-heading > span { padding: 7px 11px; border: 1px solid #bfdbfe; border-radius: 999px; background: #eff6ff; color: #1d4ed8; font-size: 12px; font-weight: 800; white-space: nowrap; }\n.application-process-timeline { position: relative; display: grid; gap: 18px; padding-left: 6px; }\n.application-process-timeline::before { position: absolute; top: 20px; bottom: 20px; left: 22px; width: 2px; background: #dbeafe; content: \"\"; }\n.application-timeline-event { position: relative; display: grid; grid-template-columns: 34px minmax(0, 1fr); gap: 16px; }\n.application-timeline-marker { z-index: 1; display: grid; width: 34px; height: 34px; place-items: center; border: 4px solid #fff; border-radius: 50%; background: #2563eb; box-shadow: 0 0 0 1px #bfdbfe; color: #fff; font-size: 13px; }\n.application-timeline-event.submitted .application-timeline-marker { background: #64748b; }\n.application-timeline-event.placed .application-timeline-marker { background: #059669; box-shadow: 0 0 0 1px #a7f3d0; }\n.application-timeline-content { min-width: 0; padding: 14px 16px; border: 1px solid #e2e8f0; border-radius: 14px; background: #fff; box-shadow: 0 4px 16px rgba(15,23,42,.04); }\n.application-timeline-title { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; }\n.application-timeline-title h4 { margin: 0; color: #0f172a; font-size: 15px; }\n.application-timeline-title time { display: inline-flex; align-items: center; gap: 5px; color: #64748b; font-size: 11px; white-space: nowrap; }\n.application-timeline-slot { display: inline-flex; align-items: center; gap: 7px; margin-top: 10px; padding: 7px 10px; border-radius: 8px; background: #eff6ff; color: #1d4ed8; font-size: 12px; font-weight: 700; }\n.application-timeline-feedback { display: flex; gap: 10px; margin-top: 12px; padding: 11px 12px; border-left: 3px solid #93c5fd; border-radius: 8px; background: #f8fafc; color: #475569; }\n.application-timeline-feedback > svg { flex: 0 0 auto; margin-top: 2px; color: #2563eb; }\n.application-timeline-feedback small { color: #64748b; font-size: 10px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; }\n.application-timeline-feedback p { margin: 3px 0 0; color: #334155; line-height: 1.55; white-space: pre-wrap; overflow-wrap: anywhere; }\n.application-timeline-author { margin-top: 9px; color: #94a3b8; font-size: 11px; text-align: right; }\n.placement-feedback-form { margin-top: 16px; }\n@media (max-width: 700px) {\n  .application-process-actions { width: 100%; justify-content: stretch; }\n  .application-process-actions .process-btn { flex: 1 1 100%; }\n  .application-process-heading, .application-timeline-title { align-items: flex-start; flex-direction: column; }\n  .application-process-heading { gap: 10px; }\n  .application-timeline-title { gap: 6px; }\n  .application-timeline-title time { white-space: normal; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
